import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};
export const OperatorSymbol = ({ children }: Props) => {
  return (
    <div className="grid place-content-center">
      <div className="grid size-x2 place-content-center rounded-full bg-p-grey-100 text-solid">
        {children}
      </div>
    </div>
  );
};
